import { Autocomplete, Button, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NotificationPopup from "../../Components/NotificationPopup";
import {
  checkLoggedInUserPcc,
  getCustomer,
  getManageBookingData,
} from "../../redux/actions/CustomerAction";
import {
  CHECK_LOGGED_IN_USER_PCC_RESET,
  GET_MANAGE_BOOKING_DATA_RESET,
} from "../../Constants/Constants";
import FullPageLoader from "../../Components/FullPageLoader";

export default function ManageMyItinerary(props) {
  const { decodedToken } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [PNR, setPNR] = useState("");
  const [PCC, setPCC] = useState("");
  const [PCCs, setPCCs] = useState([]);
  const [pccCountry, setPccCountry] = useState("");

  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [errorAlertTitle, setErrorAlertTitle] = useState("");
  const [openLoader, setOpenLoader] = useState(false);

  const GetManageBookingData = useSelector(
    (state) => state.GetManageBookingData
  );
  const {
    itineraryInfo,
    loading: itineraryloading,
    error,
  } = GetManageBookingData;

  const CheckLoggedInUserPCC = useSelector(
    (state) => state.CheckLoggedInUserPCC
  );
  const {
    loggedInUserPCCInfo,
    loggedInUserPCCerror,
    loading: loggedInUserPCCloading,
  } = CheckLoggedInUserPCC;

  const customer_id = JSON.parse(localStorage.getItem("customer_id"));
  const cust_login_id = JSON.parse(localStorage.getItem("customer_login_id"));
  const customer_user_id = JSON.parse(localStorage.getItem("customer_user_id"));

  const check_pcc_id = customer_user_id ? customer_user_id : customer_id;

  const GetLoggedInCustomer = useSelector((state) => state.GetLoggedInCustomer);
  const { loggedInCustomerInfo } = GetLoggedInCustomer;

  const GetLoggedInCustomerUser = useSelector(
    (state) => state.GetLoggedInCustomerUser
  );
  const { loggedInCustomerUserInfo } = GetLoggedInCustomerUser;

  const GetCustomers = useSelector((state) => state.GetCustomers);
  const { customersInfo } = GetCustomers;

  useEffect(() => {
    dispatch({ type: CHECK_LOGGED_IN_USER_PCC_RESET });
    dispatch({ type: GET_MANAGE_BOOKING_DATA_RESET });
  }, []);

  useEffect(() => {
    if (loggedInCustomerInfo && customer_id) {
      const pccs = loggedInCustomerInfo?.pccs?.trim()?.split(" ");
      setPCCs(pccs);
      if (pccs.length === 1) {
        setPCC(pccs[0]);
      }
    }
    if (loggedInCustomerUserInfo && customer_user_id) {
      dispatch(getCustomer());
      const pccs = loggedInCustomerUserInfo?.pccs?.trim()?.split(" ");
      setPCCs(pccs);
      if (pccs.length === 1) {
        setPCC(pccs[0]);
      }
    }
  }, [loggedInCustomerInfo, loggedInCustomerUserInfo]);

  useEffect(() => {
    if (PCC) {
      const customer = customersInfo?.find((cust) =>
        cust?.pccs?.split(" ").includes(PCC)
      );
      if (customer) {
        setPccCountry(customer.country);
      } else {
        setPccCountry("");
      }
    }
  }, [PCC, customersInfo]);

  useEffect(() => {
    if (itineraryloading) {
      setOpenLoader(true);
    } else {
      setOpenLoader(false);
    }
  }, [itineraryloading]);

  useEffect(() => {
    if (loggedInUserPCCloading) {
      setOpenLoader(true);
    } else {
      setOpenLoader(false);
    }
  }, [loggedInUserPCCloading]);

  useEffect(() => {
    if (loggedInUserPCCInfo && PNR && PCC) {
      if (decodedToken?.role === "customer_user") {
        dispatch(
          getManageBookingData(PNR, PCC, decodedToken?.role, customer_user_id)
        );
      } else {
        dispatch(getManageBookingData(PNR, PCC, decodedToken?.role,customer_id));
      }
    }
    if (loggedInUserPCCerror) {
      setErrorAlertTitle("Error");
      setErrorAlertMessage(loggedInUserPCCerror);
      setErrorAlert(true);
    }
  }, [loggedInUserPCCInfo, loggedInUserPCCerror]);

  useEffect(() => {
    if (!itineraryloading) {
      if (itineraryInfo && Object.keys(itineraryInfo).length > 0 && !error) {
        sessionStorage.setItem("pnr", PNR);
        sessionStorage.setItem("pcc", PCC);
        navigate("/dashboard/products/managemyitineraryresult");
      } else if (error) {
        setErrorAlertTitle("Error");
        setErrorAlertMessage(error);
        setErrorAlert(true);
      }
    }
  }, [itineraryloading, itineraryInfo, error]);

  const handleItineraryDisplay = () => {
    if (PNR && PCC) {
      // dispatch(getManageBookingData(PNR, PCC));
      dispatch(checkLoggedInUserPcc(check_pcc_id, PCC));
    } else {
      setErrorAlertTitle("Required field error");
      setErrorAlertMessage(
        "Please enter all the fields. PNR and PCC are required."
      );
      setErrorAlert(true);
    }
  };
  return (
    <>
      <div className="flight-bkgcol">
        <div className="wrap-mu mangbkingbk">
          <div className="container">
            <div style={{ padding: "20px" }}>
              <div className="mangemybooking">
                <div className="mangemybooking-wrapper">
                  <div className="formsection-col">
                    <Typography variant="h5" align="center" gutterBottom>
                      Manage your booking
                    </Typography>
                    <p>
                      Enter your details to see your itinerary, make changes and
                      add extra services.
                    </p>

                    <TextField
                      label="Booking PNR"
                      variant="outlined"
                      fullWidth
                      value={PNR}
                      onChange={(e) => setPNR(e.target.value)}
                      margin="normal"
                      required
                    />

                    <Autocomplete
                      size="medium"
                      value={PCC || null}
                      options={(PCCs && Object.values(PCCs)) || []}
                      getOptionLabel={(option) => option}
                      onChange={(e, value) => {
                        if (value) setPCC(value);
                      }}
                      renderInput={(params) => {
                        return (
                          <TextField
                            required
                            {...params}
                            placeholder="Select PCC *"
                          />
                        );
                      }}
                    />

                    {decodedToken?.role === "customer_user" && PCC && (
                      <Typography>
                        Selected PCC is of{" "}
                        <span style={{ fontWeight: "bold" }}>{pccCountry}</span>{" "}
                        country
                      </Typography>
                    )}

                    <Button
                      className="submit-button"
                      variant="contained"
                      color="primary"
                      fullWidth
                      type="submit"
                      sx={{ mt: 2 }}
                      onClick={handleItineraryDisplay}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {errorAlert && (
          <NotificationPopup
            open={errorAlert}
            title={errorAlertTitle}
            message={errorAlertMessage}
            onClose={() => setErrorAlert(false)}
            severity={"error"}
          />
        )}
      </div>
      {openLoader && <FullPageLoader open={openLoader} />}
    </>
  );
}
